module.exports = __webpack_public_path__ + "img/reset-view.84608960.svg";